<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page06"></a>
<a id="page07"></a>
<div class="chapterHead">
<h2 class="chapterNumber"><span class="xrefInternal"><a href="#/xhtml/contents#fm_01"><em class="italic">prologue</em></a></span></h2></div>
<div class="chapterBody">
<p class="centerImage"><img alt="image" src="images/07.jpg"/></p>
<a id="page08"></a>
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords">In the darkness,</span> it moved, searching for something tactile.</p>
<p class="para">Sensing the way, following its instincts. For instinct was almost all it had left.</p>
<p class="para">Somewhere, sometime, some-<em class="italic">when</em> it had possessed identity. It had the characteristics and physicality that bound it to a world. But those were gone now. Now it was little more than an urge: a bundled collection of needs with the barest hint of form.</p>
<p class="para">But the void around it possessed even less form.</p>
<p class="para">It knew that somewhere within this void lay the thing it sought, and so it kept moving.</p>
<p class="para">And as it moved, unfamiliar features inside it sprang to life. In a hidden fold of its being arose a thing called “language.” With that came knowledge, and consciousness. Its journey deepened.</p>
<p class="para">It passed through a cloud of something it could now call “sadness” and wept. It passed through “serenity” and its calm returned.</p>
<p class="para">Something inside it prickled. What it sought was near. Moving toward it, pushing with all its might. The prickling increased, rushing through it like a torrent of needles.</p>
<p class="para">It reveled in this sensation, for it signaled that the end of its journey was near.</p>
<p class="para">And even as this thought formed, its journey <em class="italic">did</em> end. It had reached its destination. As it basked in this victory, a new word appeared: the name for this thing it had sought so desperately, so diligently, and for so long.</p>
<p class="para">The word was…<em class="italic">radio</em>.</p>
<a id="page09"></a>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?317b9886